<script setup>
import { ref, inject, computed } from 'vue';
import { ButtonApp, MessageApp } from '@/components/utilApp';
import { KeysService, verificarLiberacaoViewModel, serialPrincipal, diasLiberacao } from '@/modules/configuracoes/keys/store/index';
import { logoOutUser } from '@/modules/configuracoes/funcionario/store';
import { useRouter } from 'vue-router';
import { props as propsFilial } from '@/modules/configuracoes/filial/store';

const propsModal = defineProps({
  visible: { type: Boolean },
});

const openClose = ref(propsModal.visible);
const loadingApp = inject('loadingApp');

function openCloseModal() {
  openClose.value = !openClose.value;
}

const router = useRouter();
const statusMessage = ref();
const btnConfirmarPagamento = ref();

const filialWithCodigo = computed({
  get: () => (`${propsFilial.value.filial.codigo} - ${propsFilial.value.filial.nome}`),
});

async function confirmarPagamento() {
  loadingApp.value?.show();
  btnConfirmarPagamento.value?.lock();
  const input = {
    serial: serialPrincipal.value,
    filial__Codigo: propsFilial.value.filial.codigo,
  };
  await KeysService.confirmarPagamento(input)
    .then((data) => {
      router.push({ name: 'home', params: { sistemaLiberado: data?.validadeFinalFormatted } });
    })
    .catch((error) => {
      statusMessage.value.setMessageBody(error?.response?.data?.Message);
    });
  btnConfirmarPagamento.value?.unlock();
  loadingApp.value?.hide();
}

async function fillLiberacao() {
  const input = {
    serial: serialPrincipal.value,
    filial__Codigo: propsFilial.value.filial.codigo,
  };
  await KeysService.fillLiberacao(input)
    .then((data) => {
      verificarLiberacaoViewModel.value = data;
    })
    .catch((error) => {
      statusMessage.value.setMessageBody(error);
    });
}

defineExpose({ propsModal, openClose, openCloseModal, fillLiberacao });
</script>
<template>
  <div v-show="openClose" class="modal fade show mt-1" id="modal_demo" tabindex="-1" aria-labelledby="modal_demo_label" aria-hidden="true" :style="'display: block'">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modal_demo_label">Pagamento licença</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="openCloseModal()"></button>
        </div>
        <div class="modal-body">
          <div class="card-body">
            <div class="row text-center justify-content-center">
              <div class="col-md-12">
                <img class="img-fluid" width="350" height="300" src="/assets/img/landing.png" alt="Página de acesso negado" />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12">
                <label class="form-label" for="filial">Filial:</label>
                <input type="text" class="form-control" v-model="filialWithCodigo" disabled>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="form-label" for="serie">Série:</label>
                <input type="text" class="form-control" v-model="serialPrincipal" disabled>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="form-label" for="liberacao">Liberação:</label>
                <input type="text" class="form-control" v-model="verificarLiberacaoViewModel.ideLiberacao" disabled>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="form-label" for="validadeInicial">Validade Inicial:</label>
                <input type="text" class="form-control" v-model="verificarLiberacaoViewModel.validadeInicialFormatted" disabled>
              </div>
              <div class="col-md-6">
                <label class="form-label" for="validadeFinal">Final:</label>
                <input type="text" class="form-control" v-model="verificarLiberacaoViewModel.validadeFinalFormatted" disabled>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <label class="form-label" for="dias">Dias restantes:</label>
                <input type="text" class="form-control" v-model="diasLiberacao" disabled>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-12 d-flex justify-content-between align-items-center flex-wrap">
                <router-link :to="{name: 'pagamentoLicenca'}">
                  <ButtonApp title="Efetuar pagamento" :marginTop="1" @click="confirm()" :variant="'flat-secondary'" :iconButton="'fa-solid fa-dollar-sign'" :styleIcon="'#06e09e;'" class="border" />
                </router-link>
                <ButtonApp title="Confirmar liberação" ref="btnConfirmarPagamento" :busy-hide-message="true" :marginTop="1" @click="confirmarPagamento()" :variant="'flat-secondary'" :iconButton="'fa-regular fa-clock'" :styleIcon="'#ff3d3d;'" class="border" />
                <ButtonApp title="Encerrar" :marginTop="1" @click="logoOutUser()" :variant="'flat-secondary'" :iconButton="'fa-solid fa-xmark'" :styleIcon="'#ff3d3d;'" class="border" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MessageApp ref="statusMessage" @hideAlert="statusMessage.hideMessage()" showClose :positionFixe="true" />
  </div>
</template>
